export const RU = 'RU';
export const UA = 'UA';
export const EN = 'EN';

export const SITE_LANG_RU = 'russian';
export const SITE_LANG_UA = 'ukranian';
export const SITE_LANG_EN = 'english';
